// extracted by mini-css-extract-plugin
export default {"Credits":"Credits_Credits__D6EdQ","CreditsLink":"Credits_CreditsLink__eVI3N"};